import {
  getCharsSummary,
  getFlowersSummary,
  getTime,
  getDeliveryCost,
  getTotal
} from './email'

const sha1 = require('sha1')

/**
 * POSTFINANCE
 * in order to send email after successful payment, email body data is sent in uri
 */
export const valuesToString = (locale, values, prices, form) => {
  const p_add = values.payment.address
  const d_add = values.delivery.address
  return encodeURI(
    `locale=${locale}&email=${[
      /* 0 = gender          */ values.chars.gender,
      /* 1 = characteristics */ getCharsSummary(values),
      /* 2 = age             */ values.chars.age,
      /* 3 = story           */ values.chars.story,

      /* 4 = bouquet price   */ prices.bouquet,
      /* 5 = bouquet size    */ values.bouquet.size,
      /* 6 = bouquet shape   */ values.bouquet.shape,
      /* 7 = bouquet color   */ getFlowersSummary(values),

      /* 8 = card            */ getCardSummary(values, form),
      /* 9 = card text       */ values.card.card_text,
      /* 10 = card price     */ prices.card,

      /* Delivery data */
      /* 11  */ d_add.given_name,
      /* 12  */ d_add.family_name,
      /* 13  */ d_add.company,
      /* 14  */ d_add.street,
      /* 15  */ d_add.house_number,
      /* 16  */ d_add.postal_code,
      /* 17  */ d_add.city,
      /* 18  */ d_add.tel,
      /* 19  */ d_add.email,

      /* Payment data */
      /* 20 */ p_add.given_name,
      /* 21 */ p_add.family_name,
      /* 22 */ p_add.company,
      /* 23 */ p_add.street,
      /* 24 */ p_add.house_number,
      /* 25 */ p_add.postal_code,
      /* 26 */ p_add.city,
      /* 27 */ p_add.tel,
      /* 28 */ p_add.email,

      /* 29 delivery comments */ values.delivery.comments,
      /* 30 delivery method   */ values.delivery.method,
      /* 31 delivery time     */ getTime(values, form),
      /* 32 delivery cost     */ getDeliveryCost(prices),

      /* 33 total cost     */ getTotal(prices),
      /* 34 payment method */ values.payment.method,
      /* 35 newsletter     */ values.summary.newsletter ? 'y' : 'n',
      /* 36 bouquet notes   */ values.bouquet.comments,
      /* 37 express delivery */ prices.urgent_delivery || 0
    ]}`
  )
}

const getCardSummary = (values, form) =>
  `${values.card.card === form.card.card.values[0] ? 'y' : 'n'}`

/**
 * SHA-IN hash generation
 */
export const getPostfinanceHash = data =>
  sha1(
    Object.keys(data).reduce(
      (acc, c, i, arr) =>
        `${acc}${arr[i]}=${data[arr[i]]}${process.env.GATSBY_POSTFINANCE_HASH}`,
      ''
    )
  ).toUpperCase()
